module.exports = {
  __init__: [ 'bpmnRenderer' ],
  bpmnRenderer: [ 'type', require(3) ],
  pathMap: [ 'type', require(4) ]
};
